import { EnvironmentalDataSource } from '@app/data/services/types/EnvironmentalDataSource';

/**
 * Extracts unique group tags from an array of EnvironmentalDataSource objects.
 */
export function extractUniqueGroupTags(dataSources: EnvironmentalDataSource[]): string[] {
  const allGroupTags: string[] = [];

  dataSources
    .filter((source) => source.map_groupings && Array.isArray(source.map_groupings))
    .forEach((source) => {
      source.map_groupings.forEach((tag) => allGroupTags.push(tag));
    });

  return [...new Set(allGroupTags)].sort();
}
